import { useQueryLoader } from "react-relay"
import { graphql } from "relay-runtime"
import { useBetterDocHealthSummaryQuery } from "@/modules/admin/better-doc/services/__generated__/useBetterDocHealthSummaryQuery.graphql"

const betterDocHealthSummaryQuery = graphql`
  query useBetterDocHealthSummaryQuery {
    de_betterDocHealthSummary {
      lastSuccessfulExchangeAt
      failedExchangeCountLast24Hours
      stuckSessions {
        waitingSince
        session {
          sessionId
          partnerSessionId
          isTestCase
          testCaseScenario
        }
      }
    }
  }
`

const useBetterDocHealthSummaryQueryLoader = () => {
  return useQueryLoader<useBetterDocHealthSummaryQuery>(betterDocHealthSummaryQuery)
}

export { betterDocHealthSummaryQuery, useBetterDocHealthSummaryQueryLoader }
